<template>
  <div class="marketplace-card-wrapper">
      <h2>Marketplace</h2>
       
            <MarketplaceSystems class="iqos iqos-long"/>
       
  </div>
</template>

<script>
import MarketplaceSystems from '@/components/marketplace/MarketplaceSystems.vue'

export default {
    components: {
        MarketplaceSystems
    }
}
</script>

<style scoped>
.marketplace-card-wrapper {
    position: relative;
}

.marketplace-card-wrapper h2 {
    color: #ededed;
   position: relative;
    
    left: 0;
    font-size: 4vh;
}

 
</style>